<template>
    <div class="mdc-dialog mdc-dialog--open mdc-dialog--loader">
        <div id="loaderContainer">
            <img src="../../../assets/images/loader.gif" alt="loader">

            <p>{{messages | trans}}</p>

        </div>
        <div class="mdc-dialog__wrappdrop"></div>
    </div>
</template>

<script>

  export default {
    props: {
      'messages': {
        type: String,
        default() {
          return 'home.labels.loading_message';
        },
      },
    },
    data() {
      return {};
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/loader/components/Loader.vue